import { fetchOrderInactiveInterface } from "../stores/dashboard/ordersSlice.ts";
import { AddTraderFormData } from "../features/Dashboard/features/Resellers/components/AddTrader.tsx";
import { BillingAddress, ShippingAddress } from "../stores/user/userSlice.types.ts";
import ApiEndpoints from "./ApiEndpoints.tsx";
//import REACT_CONFIG from "../services/REACT_CONFIG";

const checkForError = async (response: Response) => {
    if (!response.ok) throw Error(response.statusText);

    return response.json();
};

const fetchData = async (url: string, obj: object = { method: 'GET' }) => {
    const response = await fetch(url, obj);
    const res = await checkForError(response);

    if (res.status !== 'success') throw new Error(res.message);
    return res.payload;
}

const fetchPostData = async (url: string, data: object = {}) => fetchData(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' }
});

const fetchFormPostData = async (url: string, data: object = {}) => fetchData(url, {
    method: 'POST',
    body: data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
});

//const BASE_URL = REACT_CONFIG.API_URL;

export default class ApiManager {
    //static fetchAuthData = () => fetchData(ApiEndpoints.AUTH_DATA());
    static fetchInitData = () => {
        const a = fetchData(ApiEndpoints.INIT());
        console.log('post fetch!');
        return a
    };//fetchData(ApiEndpoints.INIT());

    static login = async (formData: FormData, rejectWithValue: any) => {
        try {
            const response = await fetch(ApiEndpoints.LOGIN(), {
                method: 'POST',
                body: formData,
            });

            const res = await response.json();

            // Obsługa błędów z odpowiedzi serwera
            if (!response.ok || res.error !== 0) {
                return rejectWithValue(res.info || 'Błąd logowania');
            }

            return res; // Sukces
        } catch (error) {
            return rejectWithValue('Wystąpił błąd');
        }
    }

    static logout = () => fetchData(ApiEndpoints.LOGOUT())

    static changeCurrency = (currency: string) =>
        fetchPostData(ApiEndpoints.CURRENCY(), {
            currency: currency
        })

    static search = (currentLang: string, searchTerm: string) =>
        fetchPostData(ApiEndpoints.SEARCH(currentLang), {
            term: searchTerm
        })

    //ProductPage
    static fetchProduct = (productName: string) =>
        fetchData(ApiEndpoints.PRODUCT_FETCH(productName))

    static fetchNewsletter = (data: URLSearchParams) =>
        fetchFormPostData(ApiEndpoints.NEWSLETTER(), data)

    //Dashboard
    static fetchOrdersActive = (traderId: string | number) =>
        fetchPostData(ApiEndpoints.ORDERS_ACTIVE(), {
            traderId: traderId
        })

    static fetchOrdersInactive = ({ traderId, date }: fetchOrderInactiveInterface) => {
        //console.log('raz');
        const abc = fetchPostData(ApiEndpoints.ORDERS_INACTIVE(), {
            traderId: traderId,
            date: date
        })
        //console.log('dwa')
        return abc
    }

    static fetchOrdersDetails = (orderId: string) =>
        fetchPostData(ApiEndpoints.ORDERS_DETAILS(), {
            orderId: orderId
        })

    static fetchTraders = () =>
        fetchData(ApiEndpoints.TRADERS_SHOW());

    static fetchTraderInfo = (traderId: string) =>
        fetchPostData(ApiEndpoints.TRADER_INFO(), {
            traderId: traderId
        });

    static fetchTraderDetails = (traderId: string) =>
        fetchData(ApiEndpoints.TRADER_DETAILS(traderId));

    static addTrader = (newTraderData: AddTraderFormData) =>
        fetchPostData(ApiEndpoints.TRADER_ADD(), newTraderData)

    static editTrader = (updatedTraderData: AddTraderFormData) =>
        fetchPostData(ApiEndpoints.TRADER_EDIT(), updatedTraderData)

    static fetchReOrder = (orderId: string) =>
        fetchPostData(ApiEndpoints.RE_ORDER(), {
            orderId: orderId
        })
    static reOrderAddProduct = (formData: URLSearchParams) =>
        fetchFormPostData(ApiEndpoints.RE_ORDER_ADD_PRODUCT(), formData)

    // Cart

    static fetchProducts = () =>
        fetchData(ApiEndpoints.PRODUCTS_FETCH());

    static addProduct = (productId: number, quantity: number) =>
        fetchPostData(ApiEndpoints.ADD_PRODUCT(), {
            product: productId,
            qty: quantity
        })

    static updateProductQuantity = (id: number, quantity: number) =>
        fetchPostData(ApiEndpoints.PRODUCTS_UPDATE_QUANTITY(), {
            id: id,
            quantity: quantity
        });
    static fetchPaymentMethods = () =>
        fetchData(ApiEndpoints.PAYMENT_METHODS_FETCH());

    static fetchDeliveryMethods = (data: object) =>
        fetchPostData(ApiEndpoints.DELIVERY_METHODS_FETCH(), data);

    static placeOrder = (data: object) =>
        fetchPostData(ApiEndpoints.PLACE_ORDER(), data);

    static validateBillingAddress = (data: BillingAddress) =>
        fetchPostData(ApiEndpoints.VALIDATE_BILLING_ADDRESS(), data);

    static validateShippingAddress = (form: ShippingAddress) =>
        fetchPostData(ApiEndpoints.VALIDATE_SHIPPING_ADDRESS(), form);

    static fetchSummaryData = (hash: string) =>
        fetchData(ApiEndpoints.FETCH_SUMMARY_ORDER(hash));

    static clearCart = () =>
        fetchData(ApiEndpoints.CLEAR_CART());

    static setOrderAsPaid = (orderId: string) =>
        fetchPostData(ApiEndpoints.UPDATE_RESELLER_ORDER(orderId), { paid: true });

    static setOrderStatus = (orderId: string, status: number, email: boolean) =>
        fetchPostData(ApiEndpoints.UPDATE_RESELLER_ORDER(orderId), { status: status, email: email });

    static redirectOrderToCentral = (orderId: string) =>
        fetchPostData(ApiEndpoints.UPDATE_RESELLER_ORDER(orderId), { redirectToCentral: true });

    static autoCompleteBillingAddress = (nip: string) =>
        fetchPostData(ApiEndpoints.AUTO_COMPLETE_BILLING_ADDRESS(), { nip: nip });
}